import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/pages/Home.vue'
import Login from '@/pages/Login.vue'
import FabricationCarte from '@/pages/FabricationCarte.vue'
import Erreur from '@/pages/Erreur.vue'
import Error404 from '@/pages/Error404.vue'
import Rechargement from '@/pages/Rechargement.vue'
import SuccesRechargement from '@/pages/SuccesRechargement.vue'
import SuccesAchatNFC from '@/pages/SuccesAchatNFC.vue'
import SuccesAchatQRCode from '@/pages/SuccesAchatQRCode.vue'
import Paiement from '@/pages/Paiement.vue'
import SuccesFabricationCarte from '@/pages/SuccesFabricationCarte.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Accueil - E-Boutique Lulu en bus' },
  },
  {
    path: '/fabrication-carte',
    name: 'fabrication_carte',
    component: FabricationCarte,
    meta: { title: 'Commander une carte - E-Boutique Lulu en bus' },
  },
  {
    path: '/rechargement',
    name: 'rechargement',
    component: Rechargement,
    meta: { title: 'Recharger un titre - E-Boutique Lulu en bus' },
  },
  {
    path: '/succes-fabrication-carte',
    name: 'succesfabrication_carte',
    component: SuccesFabricationCarte,
    meta: { title: '(Succès) Commande de carte - E-Boutique Lulu en bus' },
  },
  {
    path: '/succes-rechargement',
    name: 'succesRechargement',
    component: SuccesRechargement,
    meta: { title: '(Succès) Recharger un titre - E-Boutique Lulu en bus' },
  },
  {
    path: '/succes-achat-qrcode',
    name: 'succesAchatQRCode',
    component: SuccesAchatQRCode,
    props: true,
    meta: { title: '(Succès) Achat QR code - E-Boutique Lulu en bus' },
  },
  {
    path: '/succes-achat-NFC',
    name: 'succesAchatNFC',
    component: SuccesAchatNFC,
    meta: { title: '(Succès) Achat NFC - E-Boutique Lulu en bus' },
  },
  {
    path: '/depositaire',
    name: 'login',
    component: Login,
    meta: { title: 'Connexion depositaire - E-Boutique Lulu en bus' },
  },
  {
    path: '/depositaire/rechargement',
    name: 'rechargementDepositaire',
    component: Rechargement,
    props: { modeDepositaire: true },
    meta: { title: 'Rechargement depositaire - E-Boutique Lulu en bus' },
  },
  {
    path: '/depositaire/succes-rechargement',
    name: 'succesRechargementDepositaire',
    component: SuccesRechargement,
    props: { modeDepositaire: true },
    meta: { title: '(Succès) Recharger un titre - E-Boutique Lulu en bus' },
  },
  {
    path: '/depositaire/succes-achat-qrcode',
    name: 'succesAchatQRCodeDepositaire',
    component: SuccesAchatQRCode,
    props: { modeDepositaire: true },
    meta: { title: '(Succès) Achat QR code - E-Boutique Lulu en bus' },
  },
  {
    path: '/depositaire/succes-achat-NFC',
    name: 'succesAchatNFCDepositaire',
    component: SuccesAchatNFC,
    props: { modeDepositaire: true },
    meta: { title: '(Succès) Achat NFC - E-Boutique Lulu en bus' },
  },
  {
    path: '/erreur',
    name: 'erreur',
    component: Erreur,
    meta: { title: 'Erreur - E-Boutique Lulu en bus' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: Error404,
    meta: { title: 'Page introuvable - E-Boutique Lulu en bus' },
  },
  {
    path: '/paiement/:paylineToken',
    name: 'paiement',
    component: Paiement,
    props: true,
    meta: { title: 'Paiement - E-Boutique Lulu en bus' },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Accueil - E-boutique Lulu en bus'
  next()
})

export default router
